module.exports = __webpack_public_path__ + "static/media/laravel.b0ba6d0d.png";